// extracted by mini-css-extract-plugin
export default {"dragNDropIconContainer":"extraordinary-incidence-styles_dragNDropIconContainer__BmZKk","badgeCustom":"extraordinary-incidence-styles_badgeCustom__FfSyF"};